export default __webpack_public_path__ + "static/media/Megosu-Compressed-.36c90806.jpg";